import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div``;

export const Info = styled.div`
  font-size: 24px;
  font-weight: 700;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &.blue {
    color: var(--color-blue);
  }

  &.violet {
    color: var(--color-violet);
  }

  &.yellow {
    color: var(--color-yellow);
  }

  &.green {
    color: var(--color-green);
  }
`;

export const StyledLink = styled(Link)`
  font-size: 14px;
  color: var(--color-midnight-blue);
  transition: all 0.25s ease-in-out;

  &:hover,
  &:focus {
    color: var(--color-blue);
    text-decoration: none;
  }
`;

export const BasicLink = styled(Link)`
  font-size: 13px;
  color: #122a56;
  transition: all 0.3s ease-in-out;

  &:hover {
    text-decoration: none;
  }
`;
